import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import TextField from "@mui/material/TextField";
import {
  Button,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {
  GENDER_STATUS,
  GENDER_TYPES,
  MARITAL_STATUS,
  MARITAL_STATUS_VALUE,
  VISA_TYPES,
  VISA_TYPES_SLUGS,
} from "../../utils/enums";
import { useFormik } from "formik";
import {
  ApplicationById,
  CitizenshipList,
  CommonBody,
  CountryList,
  DocumentList,
  ReligionList,
} from "../../types/General";
import * as Yup from "yup";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { errorToast, showWarning, successToast } from "../../helpers";
import Loader from "../../constants/Loader";
import { isNumber } from "../../utils/validations";
import {
  useEditApplicationMutation,
  useLazyApplicationDetailsQuery,
} from "../../service/applications";
import { Autocomplete } from "@react-google-maps/api";
import { useGetCitizenshipsMutation } from "../../service/citizenship";
import { useGetCountriesMutation } from "../../service/countries";
import { useGetReligionsMutation } from "../../service/religion";
import { UploadMedia, Uploadpdf } from "../../utils/mediaUpload";
import {
  useDocumentCheckMutation,
  usePassportCheckImageMutation,
} from "../../service/auth";
import { toast } from "react-toastify";
import { useGetDocumentsMutation } from "../../service/ducuments";
import moment from "moment";

const EditApplication = () => {
  const { type, id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const agentType = queryParams.get("agentType");
  const navigate = useNavigate();

  const finalType = type === "agent" ? agentType : type;

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [autocompleteHome, setAutocompleteHome] = useState<any>(null);
  const [autocompleteResidential, setAutocompleteResidential] =
    useState<any>(null);

  const [autocompleteWork, setAutocompleteWork] = useState<any>(null);
  const [autocompleteSchool, setAutocompleteSchool] = useState<any>(null);
  const [autocompleteUniversity, setAutocompleteUniversity] =
    useState<any>(null);

  const [details, setDetails] = useState<ApplicationById | null>(null);

  const [visaType, setVisaType] = useState("default");
  const [civilStatus, setCivilStatus] = useState("default");
  const [visaAppliedCountry, setVisaAppliedCountry] = useState("default");
  const [countryOfBirth, setCountryOfBirth] = useState("default");
  const [gender, setGender] = useState("default");
  const [religion, setReligion] = useState("default");
  const [citizenship, setCitizenship] = useState("default");
  const [countryOfResidence, setCountryOfResidence] = useState("default");
  const [hasParticipatedStateExam, setHasParticipatedStateExam] =
    useState<any>();

  const [
    countryOfSchoolLeavingCertificate,
    setCountryOfSchoolLeavingCertificate,
  ] = useState("default");

  const [citizenshipData, setCitizenshipData] = useState<CitizenshipList[]>([]);
  const [countriesData, setCountriesData] = useState<CountryList[]>([]);
  const [religionData, setReligionData] = useState<ReligionList[]>([]);
  const [documentsListData, setDocumentsListData] = useState<DocumentList[]>(
    []
  );
  const [profileImage, setProfileImage] = useState("");

  const [profile_picture_id, setProfile_picture_id] = useState<number | null>(
    null
  );
  const [contractScannedDocument, setContractScannedDocument] = useState("");

  const [contractScannedDocumentId, setContractScannedDocumentId] = useState<
    number | null
  >(null);

  const [schoolLeavingCertificate, setSchoolLeavingCertificate] = useState("");
  const [schoolLeavingCertificateId, setSchoolLeavingCertificateId] = useState<
    number | null
  >(null);

  const [universityCertificate, setUniversityCertificate] = useState("");
  const [universityCertificateId, setUniversityCertificateId] = useState<
    number | null
  >(null);

  const [identityProofDocuments, setIdentityProofDocuments] = useState<
    string[]
  >([]);
  const [identityProofDocumentsId, setIdentityProofDocumentsId] = useState<
    number[]
  >([]);
  const [otherDocuments, setOtherDocuments] = useState<
    Record<number, { url: string; id: number; name: string }>
  >({});
  const [languageInput, setLanguageInput] = useState("");

  const [applicationDetail] = useLazyApplicationDetailsQuery();
  const [updateApplication] = useEditApplicationMutation();
  const [citizenshipList] = useGetCitizenshipsMutation();
  const [countriesList] = useGetCountriesMutation();
  const [religionList] = useGetReligionsMutation();
  const [passportCheckApi] = usePassportCheckImageMutation();
  const [documentCheckApi] = useDocumentCheckMutation();
  const [documentsList] = useGetDocumentsMutation();

  const getCitizenshipList = async () => {
    setLoading(true);
    try {
      const body = {
        start: 1,
        length: 1000,
        search: "",
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await citizenshipList(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setCitizenshipData(response?.data?.response_object || []);
      } else {
        setCitizenshipData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };
  const getCountriesList = async () => {
    setLoading(true);
    try {
      const body = {
        start: 1,
        length: 1000,
        search: "",
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await countriesList(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setCountriesData(response?.data?.response_object || []);
      } else {
        setCountriesData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };
  const getReligionList = async () => {
    setLoading(true);
    try {
      const body = {
        start: 1,
        length: 1000,
        search: "",
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await religionList(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setReligionData(response?.data?.response_object || []);
      } else {
        setReligionData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };
  const getDocumentsList = async (visaType: number) => {
    setLoading(true);
    try {
      const body = {
        start: 1,
        length: 100,
        search: "",
        visa_type: visaType,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await documentsList(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setDocumentsListData(response?.data?.response_object || []);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };
  const handleLanguageChange = (e) => {
    const val = e.target.value;

    // Prevent starting with just space or dot
    if (val === " " || val === ".") return;

    // Check for comma at the end
    if (val.endsWith(",")) {
      const trimmed = val.slice(0, -1).trim();
      if (trimmed.length) {
        formik.setFieldValue("language", [...formik.values.language, trimmed]);
      }
      setLanguageInput(""); // Clear the input after comma
    } else {
      setLanguageInput(val);
    }
  };

  const handleVisaType = (event: SelectChangeEvent) => {
    setVisaType(event.target.value as string);
  };
  const handleVisaAppliedCountry = (event: SelectChangeEvent) => {
    setVisaAppliedCountry(event.target.value as string);
  };
  const handleCivilStatus = (event: SelectChangeEvent) => {
    setCivilStatus(event.target.value as string);
  };
  const handleCountryfBirth = (event: SelectChangeEvent) => {
    setCountryOfBirth(event.target.value as string);
  };
  const handleGender = (event: SelectChangeEvent) => {
    setGender(event.target.value as string);
  };
  const handleReligion = (event: SelectChangeEvent) => {
    setReligion(event.target.value as string);
  };
  const handleCitizenship = (event: SelectChangeEvent) => {
    setCitizenship(event.target.value as string);
  };
  const handleCountryOfIssuingSchoolLeavingCertificate = (
    event: SelectChangeEvent
  ) => {
    setCountryOfSchoolLeavingCertificate(event.target.value as string);
  };
  const handleCountryOfResidence = (event: SelectChangeEvent) => {
    setCountryOfResidence(event.target.value as string);
  };

  const handleChangeResidencePhone = (phone: any, country: any) => {
    formik.setFieldValue(
      "residencePhone",
      phone?.replace(country.dialCode, "")
    );
    formik.setFieldValue("residenceDialCode", country?.dialCode);
    formik.setFieldValue("residenceCountryCode", country?.countryCode);
  };
  const handleChangeEmployerPhone = (phone: any, country: any) => {
    formik.setFieldValue("employerPhone", phone?.replace(country.dialCode, ""));
    formik.setFieldValue("employerDialCode", country?.dialCode);
    formik.setFieldValue("employerCountryCode", country?.countryCode);
  };

  const onLoadHome = (autocompleteObj: any) => {
    setAutocompleteHome(autocompleteObj);
  };
  const onLoadWork = (autocompleteObj: any) => {
    setAutocompleteWork(autocompleteObj);
  };
  const onLoadResidential = (autocompleteObj: any) => {
    setAutocompleteResidential(autocompleteObj);
  };
  const onLoadSchool = (autocompleteObj: any) => {
    setAutocompleteSchool(autocompleteObj);
  };
  const onLoadUniversity = (autocompleteObj: any) => {
    setAutocompleteUniversity(autocompleteObj);
  };
  const onPlaceChangedHome = async () => {
    if (autocompleteHome) {
      const place = await (autocompleteHome as any).getPlace();

      if (place && place.address_components) {
        const address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          const types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        // setAddress(true);
        formik.setFieldValue("homeAddress", `${place?.formatted_address}`);
        formik.setFieldValue("homeCity", city || "");
        formik.setFieldValue("homeState", state || "");
        formik.setFieldValue("homePincode", zip || "");
        formik.setFieldValue("homeLat", lat || "");
        formik.setFieldValue("homeLng", lng || "");
        formik.setFieldValue("homeCountry", country || "");
      }
    }
  };

  const onPlaceChangeResidential = async () => {
    if (autocompleteResidential) {
      const place = await (autocompleteResidential as any).getPlace();

      if (place && place.address_components) {
        const address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          const types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        // setAddress(true);
        formik.setFieldValue(
          "residentialAddress",
          `${place?.formatted_address}`
        );
        formik.setFieldValue("residentialCity", city || "");
        formik.setFieldValue("residentialState", state || "");
        formik.setFieldValue("residentialPincode", zip || "");
        formik.setFieldValue("residentialLat", lat || "");
        formik.setFieldValue("residentialLng", lng || "");
        formik.setFieldValue("residentialCountry", country || "");
      }
    }
  };
  const onPlaceChangeWork = async () => {
    if (autocompleteWork) {
      const place = await (autocompleteWork as any).getPlace();

      if (place && place.address_components) {
        const address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          const types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        // setAddress(true);
        formik.setFieldValue("workAddress", `${place?.formatted_address}`);
        formik.setFieldValue("workCity", city || "");
        formik.setFieldValue("workState", state || "");
        formik.setFieldValue("workPincode", zip || "");
        formik.setFieldValue("workLat", lat || "");
        formik.setFieldValue("workLng", lng || "");
        formik.setFieldValue("workCountry", country || "");
      }
    }
  };
  const onPlaceChangeSchool = async () => {
    if (autocompleteSchool) {
      const place = await (autocompleteSchool as any).getPlace();

      if (place && place.address_components) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        formik.setFieldValue("school_address", `${place?.formatted_address}`);
        formik.setFieldValue("school_latitude", lat || "");
        formik.setFieldValue("school_longitude", lng || "");
      }
    }
  };
  const onPlaceChangeUniversity = async () => {
    if (autocompleteUniversity) {
      const place = await (autocompleteUniversity as any).getPlace();

      if (place && place.address_components) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        formik.setFieldValue(
          "university_address",
          `${place?.formatted_address}`
        );
        formik.setFieldValue("university_latitude", lat || "");
        formik.setFieldValue("university_longitude", lng || "");
      }
    }
  };
  const handleIdentityUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) return;

    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];
    if (!validTypes.includes(file.type)) {
      errorToast("Only JPG, JPEG, PNG or PDF files are allowed");
      return;
    }

    const isPDF = file.type === "application/pdf";
    const hasPDF = identityProofDocuments?.some((doc) => doc.endsWith(".pdf"));
    const imageCount = identityProofDocuments.filter(
      (doc) => !doc.endsWith(".pdf")
    ).length;

    if (isPDF && identityProofDocuments.length > 0) {
      errorToast("You can only upload a PDF or images, not both.");
      return;
    }

    if (!isPDF && hasPDF) {
      errorToast("You can only upload a PDF or images, not both.");
      return;
    }

    if (!isPDF && imageCount >= 2) {
      errorToast("You can upload a maximum of 2 images.");
      return;
    }

    const uploadResponse = isPDF
      ? await Uploadpdf(file)
      : await UploadMedia(file);

    if (uploadResponse?.data?.[0]?.media_url) {
      const url = uploadResponse.data[0].media_url;
      const id = uploadResponse.data[0].id;

      const body = { image_link: url };
      setLoading(true);
      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await documentCheckApi(encryptedBody).unwrap();
        setLoading(false);

        if (response?.status === 200) {
          if (response?.data?.contains_identity_document) {
            setIdentityProofDocuments((prev) => [...prev, url]);
            setIdentityProofDocumentsId((prev) => [...prev, id]);
          } else {
            toast.warning("Please upload a valid document");
          }
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        setLoading(false);
      }
    }
  };

  const handleContractUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setContractScannedDocument("");
      setContractScannedDocumentId(null);
      return;
    }

    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];

    if (file && file.type && !validTypes.includes(file.type)) {
      errorToast("Only JPG, JPEG, PNG or PDF files are allowed");
      return;
    }
    let uploadResponse: any;

    if (file.type === "application/pdf") {
      uploadResponse = await Uploadpdf(file);
    } else {
      uploadResponse = await UploadMedia(file);
    }
    // const imageUrl = (await UploadMedia(file)) as any;
    if (uploadResponse?.data?.[0]?.media_url) {
      handleDocumentCheck(
        uploadResponse?.data?.[0]?.media_url,
        uploadResponse?.data?.[0]?.id
      );
    }
  };
  const handleUniversityCertificateUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setUniversityCertificate("");
      setUniversityCertificateId(null);
      return;
    }

    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];

    if (file && file.type && !validTypes.includes(file.type)) {
      errorToast("Only JPG, JPEG, PNG or PDF files are allowed");
      return;
    }
    let uploadResponse: any;

    if (file.type === "application/pdf") {
      uploadResponse = await Uploadpdf(file);
    } else {
      uploadResponse = await UploadMedia(file);
    }
    if (uploadResponse?.data?.[0]?.media_url) {
      const body = {
        image_link: uploadResponse?.data?.[0]?.media_url,
      };
      try {
        setLoading(true);
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await documentCheckApi(encryptedBody).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          if (response?.data?.contains_identity_document) {
            setUniversityCertificate(
              uploadResponse?.data?.[0]?.media_url || ""
            );
            setUniversityCertificateId(uploadResponse?.data?.[0]?.id || null);
          } else {
            toast.warning("Please upload a valid document");
          }
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        setLoading(false);
      }
    }
  };
  const handleSchoolLeavingCertificateUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setSchoolLeavingCertificate("");
      setSchoolLeavingCertificateId(null);
      return;
    }

    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];

    if (file && file.type && !validTypes.includes(file.type)) {
      errorToast("Only JPG, JPEG, PNG or PDF files are allowed");
      return;
    }
    let uploadResponse: any;

    if (file.type === "application/pdf") {
      uploadResponse = await Uploadpdf(file);
    } else {
      uploadResponse = await UploadMedia(file);
    }
    if (uploadResponse?.data?.[0]?.media_url) {
      const body = {
        image_link: uploadResponse?.data?.[0]?.media_url,
      };
      try {
        setLoading(true);
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await documentCheckApi(encryptedBody).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          if (response?.data?.contains_identity_document) {
            setSchoolLeavingCertificate(
              uploadResponse?.data?.[0]?.media_url || ""
            );
            setSchoolLeavingCertificateId(
              uploadResponse?.data?.[0]?.id || null
            );
          } else {
            toast.warning("Please upload a valid document");
          }
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        setLoading(false);
      }
    }
  };

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setProfileImage("");
      setProfile_picture_id(null);
      return;
    }

    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];

    if (file && file.type && !validTypes.includes(file.type)) {
      errorToast("Only JPG, JPEG, PNG or PDF files are allowed");
      return;
    }
    let uploadResponse: any;

    if (file.type === "application/pdf") {
      uploadResponse = await Uploadpdf(file);
    } else {
      uploadResponse = await UploadMedia(file);
    }
    // const imageUrl = (await UploadMedia(file)) as any;
    if (uploadResponse?.data?.[0]?.media_url) {
      passportCheck(
        uploadResponse?.data?.[0]?.media_url,
        uploadResponse?.data?.[0]?.id
      );
    }
  };

  const passportCheck = async (url: string, id: number) => {
    const body = {
      image_link: url,
    };
    setLoading(true);
    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await passportCheckApi(encryptedBody).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        setProfileImage(url || "");
        setProfile_picture_id(id || null);
        formik.setFieldValue("firstName", response?.data?.first_name || "");
        formik.setFieldValue("middleName", response?.data?.middle_name || "");
        formik.setFieldValue("lastName", response?.data?.last_name || "");
        formik.setFieldValue(
          "passportNo",
          response?.data?.passport_number || ""
        );
        formik.setFieldValue("dob", formatDate(response?.data?.dob) || "");
        formik.setFieldValue(
          "issueDate",
          formatDate(response?.data?.issue_date) || ""
        );
        formik.setFieldValue(
          "expiryDate",
          formatDate(response?.data?.expiry_date) || ""
        );
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleDocumentCheck = async (url: string, id: number) => {
    const body = {
      image_link: url,
    };
    setLoading(true);
    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await documentCheckApi(encryptedBody).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        if (response?.data?.contains_identity_document) {
          setContractScannedDocument(url || "");
          setContractScannedDocumentId(id || null);
        } else {
          toast.warning("Please upload a valid document");
        }
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleOtherDocumentsUpload = async (
    event: any,
    docMeta: { docid: number; name: string }
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];

    if (!validTypes.includes(file.type)) {
      errorToast("Only JPG, JPEG, PNG or PDF files are allowed");
      return;
    }

    let uploadResponse: any;
    if (file.type === "application/pdf") {
      uploadResponse = await Uploadpdf(file);
    } else {
      uploadResponse = await UploadMedia(file);
    }

    const mediaUrl = uploadResponse?.data?.[0]?.media_url;
    const mediaId = uploadResponse?.data?.[0]?.id;

    if (!mediaUrl || !mediaId) return;

    const body = { image_link: mediaUrl };
    setLoading(true);
    try {
      const encryptedBody = generateEncryptedKeyBody(body) as any;
      const response = await documentCheckApi(encryptedBody).unwrap();
      setLoading(false);

      if (
        response?.status === 200 &&
        response?.data?.contains_identity_document
      ) {
        setOtherDocuments((prev) => ({
          ...prev,
          [docMeta.docid]: {
            url: mediaUrl,
            id: mediaId,
            name: docMeta.name,
          },
        }));
      } else {
        toast.warning("Please upload a valid document");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };
  const getApplicationDetails = async (id: number) => {
    setLoading(true);

    try {
      const response = await applicationDetail({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        const applicationDetails = response?.data as ApplicationById | null;
        if (applicationDetails?.visa_type_id !== undefined) {
          getDocumentsList(applicationDetails.visa_type_id);
        }
        setDetails(applicationDetails);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const formatDate = (dateStr: any) => {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`; // Convert to YYYY-MM-DD
  };

  useEffect(() => {
    setVisaType(details?.visa_type_id?.toString() || "default");
    setVisaAppliedCountry(
      details?.visa_for_country_id?.toString() || "default"
    );
    setCivilStatus(details?.martial_status?.toString() || "default");
    setCountryOfBirth(details?.country_of_birth_id?.toString() || "default");
    setGender(details?.gender?.toString() || "default");
    setReligion(details?.religion_id?.toString() || "default");
    setCitizenship(details?.citizenship_id?.toString() || "default");
    setCountryOfResidence(
      details?.country_of_residence_id?.toString() || "default"
    );
    setProfileImage(details?.passport_proof?.[0]?.media_url || "");
    setProfile_picture_id(details?.passport_proof?.[0]?.id || null);
    setContractScannedDocument(details?.contract_proof?.[0]?.media_url || "");
    setContractScannedDocumentId(details?.contract_proof?.[0]?.id || null);
    setSchoolLeavingCertificate(details?.school_cert?.[0]?.media_url || "");
    setSchoolLeavingCertificateId(details?.school_cert?.[0]?.id || null);
    setUniversityCertificate(details?.state_exam_cert?.[0]?.media_url || "");
    setUniversityCertificateId(details?.state_exam_cert?.[0]?.id || null);

    setIdentityProofDocuments(
      (details?.identity_proof || [])?.map((item: any) => item?.media_url || "")
    );
    setIdentityProofDocumentsId(
      (details?.identity_proof || [])?.map((item: any) => item?.id || null)
    );
    const extraDocs = (details?.extra_documents || []).reduce(
      (acc: any, item: any) => {
        if (item?.docid) {
          acc[item.docid] = {
            url: item.media_url,
            id: item.id,
            name: item.name,
          };
        }
        return acc;
      },
      {}
    );
    setOtherDocuments(extraDocs);
    setHasParticipatedStateExam(details?.state_exam_participation);
    setCountryOfSchoolLeavingCertificate(
      details?.school_cert_country?.id?.toString() || "default"
    );
  }, [details]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fullName: details?.full_name || "",
      email: details?.email || "",
      dialCode: details?.country_code || "+971",
      countryCode: details?.country_idd || "ae",
      phone: details?.phone_no || "",
      homeAddress: details?.address || "",
      homeCity: details?.city || "",
      homeState: details?.state || "",
      homePincode: details?.pin_code || "",
      homeLat: details?.latitude || "",
      homeLng: details?.longitude || "",
      homeCountry: details?.address_country || "",
      residentialAddress: details?.residence_address || "",
      residentialCity: details?.residence_city || "",
      residentialState: details?.residence_state || "",
      residentialPincode: details?.residence_pin_code || "",
      residentialLat: details?.residence_latitude || "",
      residentialLng: details?.residence_longitude || "",
      residentialCountry: details?.residence_country || "",
      workAddress: details?.work_address || "",
      workCity: details?.work_city || "",
      workState: details?.work_state || "",
      workPincode: details?.work_pin_code || "",
      workLat: details?.work_latitude || "",
      workLng: details?.work_longitude || "",
      workCountry: details?.work_country || "",
      placeOfBirth: details?.place_of_birth || "",
      residenceDialCode: details?.residence_country_code || "+971",
      residenceCountryCode: details?.residence_country_id || "ae",
      residencePhone: details?.residence_phone_no || "",
      employerDialCode: details?.work_company_country_code || "",
      employerCountryCode: details?.work_company_country_id || "ae",
      employerPhone: details?.work_company_phone_no || "",
      employerEmail: details?.work_company_email || "",
      residenceId: details?.residence_id || "",
      currentJobProfession: details?.current_job || "",
      companyName: details?.work_company_name || "",
      appliedPosition: details?.applied_position || "",
      visaExpiryDate: details?.visa_expiry_date || "",
      firstName: details?.first_name || "",
      middleName: details?.middle_name || "",
      lastName: details?.last_name || "",
      dob: details?.birthdate || "",
      passportNo: details?.passport || "",
      issueDate: details?.passport_issued_date || "",
      expiryDate: details?.passport_expiry_date || "",

      //
      course_name: details?.course_of_study || "",
      school_leaving_certificate: details?.school_cert_name || "",
      school_name: details?.school_name || "",
      school_address: details?.school_address || "",
      school_longitude: details?.school_longitude || "",
      school_latitude: details?.school_latitude || "",

      university_name: details?.university_name || "",
      university_address: details?.university_address || "",
      university_latitude: details?.university_latitude || "",
      university_longitude: details?.university_longitude || "",
      language: details?.language || [],
      marks_obtained: details?.state_exam_score || "",
      exam_date: details?.state_exam_date || "",
    },

    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address!"
        ),
      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Minimum 6 digits are required")
        .max(16, "Maximum 16 digits are allowed"),
      fullName: Yup.string()
        .required("Full name is required")
        .min(2, "Minimum 2 characters are required"),
      homeAddress: Yup.string().required("Address is required"),
      homeCity: Yup.string().required("City is required"),
      homePincode: Yup.string()
        .required("Postal code is required")
        .label("Postal Code")
        .min(4, "Minimum 4 digits are required"),
      homeState: Yup.string().required("State is required"),
      homeCountry: Yup.string().required("Country is required"),
      //
      workAddress: Yup.string().required("Address is required"),
      workCity: Yup.string().required("City is required"),
      workPincode: Yup.string()
        .required("Postal code is required")
        .label("Postal Code")
        .min(4, "Minimum 4 digits are required"),
      workState: Yup.string().required("State is required"),
      // workCountry: Yup.string().required("Country is required"),
      residentialAddress: Yup.string().required("Address is required"),
      residentialCity: Yup.string().required("City is required"),
      residentialPincode: Yup.string()
        .required("Postal code is required")
        .label("Postal Code")
        .min(4, "Minimum 4 digits are required"),
      residentialState: Yup.string().required("State is required"),
      residentialCountry: Yup.string().required("Country is required"),
      placeOfBirth: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      residencePhone: Yup.string()
        .required("This field is required")
        .min(6, "Minimum 6 digits are required")
        .max(16, "Maximum 16 digits are allowed"),
      employerPhone: Yup.string()
        .required("This field is required")
        .min(6, "Minimum 6 digits are required")
        .max(16, "Maximum 16 digits are allowed"),
      employerEmail: Yup.string()
        .required("This field is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address!"
        ),
      residenceId: Yup.string()
        .required("This field is required")
        .min(6, "Minimum 6 characters are required"),
      currentJobProfession: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      companyName: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      appliedPosition: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      firstName: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),

      passportNo: Yup.string()
        .required("This field is required")
        .min(4, "Minimum 4 digits are required"),
      course_name:
        finalType === VISA_TYPES_SLUGS.STUDY_VISA
          ? Yup.string()
              .required("This field is required")
              .min(3, "Minimum 3 characters are required")
          : Yup.string().notRequired(),
      school_leaving_certificate:
        finalType === VISA_TYPES_SLUGS.STUDY_VISA
          ? Yup.string()
              .required("This field is required")
              .min(3, "Minimum 3 characters are required")
          : Yup.string().notRequired(),
      school_name:
        finalType === VISA_TYPES_SLUGS.STUDY_VISA
          ? Yup.string()
              .required("This field is required")
              .min(3, "Minimum 3 characters are required")
          : Yup.string().notRequired(),
      school_address:
        finalType === VISA_TYPES_SLUGS.STUDY_VISA
          ? Yup.string().required("This field is required")
          : Yup.string().notRequired(),
      university_name:
        finalType === VISA_TYPES_SLUGS.STUDY_VISA
          ? Yup.string()
              .required("This field is required")
              .min(3, "Minimum 3 characters are required")
          : Yup.string().notRequired(),
      university_address:
        finalType === VISA_TYPES_SLUGS.STUDY_VISA
          ? Yup.string().required("This field is required")
          : Yup.string().notRequired(),
      // language:
      //   finalType === VISA_TYPES_SLUGS.STUDY_VISA
      //     ? Yup.array()
      //         .of(Yup.string().trim().min(1, "Cannot be empty"))
      //         .min(1, "At least one language is required")
      //         .required("This field is required")
      //     : Yup.array().of(Yup.string().trim()).notRequired(),
      marks_obtained:
        finalType === VISA_TYPES_SLUGS.STUDY_VISA && hasParticipatedStateExam
          ? Yup.string().required("This field is required")
          : Yup.string().notRequired(),
    }),

    onSubmit: async (values: any) => {
      formik.setSubmitting(true);
      const modifiedOtherDocuments = Object.entries(otherDocuments).map(
        ([docid, { id, name }]) => ({
          docid: Number(docid),
          id: Number(id),
          name,
        })
      );
      const allOtherDocsUploaded = documentsListData.every((doc) => {
        const uploaded = otherDocuments[doc?.id];
        return uploaded?.url && uploaded?.id && uploaded?.name;
      });

      if (!values?.homeLat || !values?.homeLat) {
        showWarning("Please select a valid home address.");
        return;
      }
      if (!values?.workLat || !values?.workLng) {
        showWarning("Please select a valid work address.");
        return;
      }
      if (!values?.residentialLat || !values?.residentialLng) {
        showWarning("Please select a valid residential address.");
        return;
      }

      if (!profile_picture_id) {
        errorToast("Please upload passport");
        return;
      }

      if (!contractScannedDocumentId) {
        errorToast("Please upload contract scannned document");
        return;
      }
      if (!identityProofDocumentsId?.length) {
        errorToast("Please upload identity proof documents");
        return;
      }
      if (!allOtherDocsUploaded) {
        errorToast("Please upload all additional documents");
        return;
      }
      if (hasParticipatedStateExam == undefined) {
        errorToast(
          "Please select yes or no option for participation in state exam"
        );
        return;
      }
      if (hasParticipatedStateExam && !formik.values.exam_date?.length) {
        errorToast("Please select the exam date");
        return;
      }
      if (
        finalType === VISA_TYPES_SLUGS.STUDY_VISA &&
        (!values?.school_longitude || !values?.school_latitude)
      ) {
        showWarning("Please select a valid school address.");
        return;
      }
      if (
        finalType === VISA_TYPES_SLUGS.STUDY_VISA &&
        (!values?.university_longitude || !values?.university_latitude)
      ) {
        showWarning("Please select a valid university address.");
        return;
      }
      if (
        finalType === VISA_TYPES_SLUGS.STUDY_VISA &&
        !universityCertificateId
      ) {
        errorToast("Please upload university certificate");
        return;
      }
      if (
        finalType === VISA_TYPES_SLUGS.STUDY_VISA &&
        !schoolLeavingCertificateId
      ) {
        errorToast("Please upload school leaving certificate");
        return;
      }
      if (
        finalType === VISA_TYPES_SLUGS.STUDY_VISA &&
        countryOfSchoolLeavingCertificate === "default"
      ) {
        errorToast(
          "Please select country of issuing school leaving certificate"
        );
        return;
      }

      const finalLanguages = [...formik.values.language];

      // If there's any unsubmitted value in the input field (not added via comma)
      if (languageInput.trim()) {
        finalLanguages.push(languageInput.trim());
      }
      if (
        finalType === VISA_TYPES_SLUGS.STUDY_VISA &&
        !finalLanguages?.length
      ) {
        errorToast("Language is a required field.");
        return;
      }

      const body = {
        full_name:
          [values.firstName, values.middleName, values.lastName]
            .filter(Boolean)
            .join(" ") || values.fullName,
        first_name: values.firstName,
        middle_name: values.middleName,
        last_name: values.lastName,
        phone_no: values.phone,
        country_code:
          (values.dialCode.includes("+") ? "" : "+") + values.dialCode,
        country_idd: values.countryCode,
        passport: values.passportNo,
        passport_issued_date: values.issueDate,
        birthdate: values.dob,
        passport_expiry_date: values.expiryDate,
        passport_proof: [Number(profile_picture_id)],
        passport_issued_by: null,
        place_of_birth: values.placeOfBirth,
        gender: Number(gender),
        address: values.homeAddress,
        state: values.homeState,
        city: values.homeCity,
        address_country: values.homeCountry,
        pin_code: values.homePincode,
        latitude: Number(values.homeLat),
        longitude: Number(values.homeLng),
        country_of_birth: Number(countryOfBirth),
        citizenship: Number(citizenship),

        country_of_residence: Number(countryOfResidence),
        religion: Number(religion),
        martial_status: Number(civilStatus),

        residence_country_code:
          (values.residenceDialCode.includes("+") ? "" : "+") +
          values.residenceDialCode,
        residence_country_id: values.residenceCountryCode?.toUpperCase(),
        residence_phone_no: values.residencePhone,
        residence_id: values.residenceId,
        visa_for_country: Number(visaAppliedCountry),
        visa_expiry_date: values.visaExpiryDate,
        current_job: values.currentJobProfession,
        work_state: values.workState,
        work_city: values.workCity,
        // work_country: values.workCountry,
        work_pin_code: values.workPincode,
        work_latitude: Number(values.workLat),
        work_longitude: Number(values.workLng),
        work_address: values.workAddress,
        work_company_name: values.companyName,
        work_company_phone_no:
          (values.employerPhone.includes("+") ? "" : "+") +
          values.employerPhone,
        work_company_country_code: values.employerDialCode,
        work_company_country_id: values.employerCountryCode?.toUpperCase(),
        work_company_email: values.employerEmail,
        applied_position: values.appliedPosition,

        residence_address: values?.residentialAddress || "",
        residence_city: values?.residentialCity || "",
        residence_state: values?.residentialState || "",
        residence_pin_code: values?.residentialPincode || "",
        residence_latitude: Number(values?.residentialLat),
        residence_longitude: Number(values?.residentialLng),
        residence_country: values.residentialCountry || "",
        contract_proof: [Number(contractScannedDocumentId)],
        identity_proof: identityProofDocumentsId,
        extra_documents: modifiedOtherDocuments,
        //

        ...(finalType === VISA_TYPES_SLUGS.STUDY_VISA
          ? {
              course_of_study: values.course_name,
              school_cert_country: Number(countryOfSchoolLeavingCertificate),
              school_cert_name: values.school_leaving_certificate,
              school_name: values.school_name,
              school_address: values.school_address,
              school_longitude: values.school_longitude,
              school_latitude: values.school_latitude,
              university_name: values.university_name,
              university_address: values.university_address,
              university_latitude: values.university_latitude,
              university_longitude: values.university_longitude,
              language: finalLanguages,
              state_exam_participation: hasParticipatedStateExam,
              ...(hasParticipatedStateExam
                ? { state_exam_score: values?.marks_obtained }
                : {}),
              ...(hasParticipatedStateExam
                ? { state_exam_date: values?.exam_date }
                : {}),
              state_exam_cert: [Number(universityCertificateId)],
              school_cert: [Number(schoolLeavingCertificateId)],
            }
          : null),
      };

      try {
        setLoading(true);
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

        const response = await updateApplication({
          body: encryptedBody,
          id: Number(id),
        }).unwrap();

        if (response?.status === 200) {
          setLoading(false);

          successToast("Application details updated successfully");
          getApplicationDetails(Number(id));
        } else {
          setLoading(false);
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (id) {
      getApplicationDetails(Number(id));
    }
  }, []);

  useEffect(() => {
    getCitizenshipList();
    getCountriesList();
    getReligionList();
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>Edit Application Details</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Manage Applications - Edit Application
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="gap_p">
            <h5 className="sub_hdng">General Details</h5>

            {/* Visa Type */}
            <div className="control_group w_50">
              <label>Select Visa Type</label>
              <Select
                fullWidth
                labelId="visaType"
                id="visaType"
                value={visaType}
                onChange={handleVisaType}
                disabled={id ? true : false}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                <MenuItem value={VISA_TYPES.TOURIST_VISA}>Visit Visa</MenuItem>
                <MenuItem value={VISA_TYPES.STUDY_VISA}>Study Visa</MenuItem>
                <MenuItem value={VISA_TYPES.WORK_VISA}>Work Visa</MenuItem>
                <MenuItem value={VISA_TYPES.BUSINESS_VISA}>
                  Business Visa
                </MenuItem>
              </Select>
            </div>
            {/* Visa Applied Country */}
            <div className="control_group w_50">
              <label>Select Visa Applied Country</label>
              <Select
                fullWidth
                labelId="visaAppliedCountry"
                id="visaAppliedCountry"
                value={visaAppliedCountry}
                onChange={handleVisaAppliedCountry}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                {countriesData?.length
                  ? countriesData?.map((item) => {
                      return (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.country_name || "-"}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
              {error && visaAppliedCountry === "default" ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            {/* Full Name */}
            <div className="control_group w_50">
              <label>Full Name</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="fullName"
                disabled
                id="fullName"
                inputProps={{ maxLength: 80 }}
                value={formik.values.fullName}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.fullName && formik.errors.fullName}
              />
            </div>
            {/* Email */}
            <div className="control_group w_50">
              <label>E-mail</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                className="text_field"
                hiddenLabel
                name="email"
                id="email"
                fullWidth
                inputProps={{ maxLength: 80 }}
                value={formik.values.email}
                disabled
                onBlur={formik.handleBlur}
                helperText={formik.touched.email && formik.errors.email}
              />
            </div>
            {/* Phone Number */}
            <div className="control_group w_50">
              <label>Contact Number</label>
              <PhoneInput
                enableSearch
                value={formik.values.dialCode + formik.values.phone}
                country={"us"}
                inputClass="phoneInput"
                inputStyle={{ width: "100%" }}
                buttonClass="phoneBtn"
                placeholder="Contact Number"
                disabled
              />
            </div>
            {/* Civil Status */}
            <div className="control_group w_50">
              <label>Select Civil Status</label>
              <Select
                fullWidth
                labelId="civilStatus"
                id="civilStatus"
                value={civilStatus}
                onChange={handleCivilStatus}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                <MenuItem value={MARITAL_STATUS_VALUE.SINGLE}>
                  {MARITAL_STATUS[1]}
                </MenuItem>
                <MenuItem value={MARITAL_STATUS_VALUE.MARRIED}>
                  {MARITAL_STATUS[2]}
                </MenuItem>
                <MenuItem value={MARITAL_STATUS_VALUE.DIVORCED}>
                  {MARITAL_STATUS[3]}
                </MenuItem>
                <MenuItem value={MARITAL_STATUS_VALUE.SEPARATED}>
                  {MARITAL_STATUS[4]}
                </MenuItem>
                <MenuItem value={MARITAL_STATUS_VALUE.OTHER}>
                  {MARITAL_STATUS[5]}
                </MenuItem>
              </Select>
              {error && civilStatus === "default" ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            {/* Home Address */}
            <div className="control_group w_50">
              <label>Home Address</label>
              <Autocomplete
                onLoad={onLoadHome}
                onPlaceChanged={onPlaceChangedHome}
              >
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  className="text_field"
                  name="homeAddress"
                  id="homeAddress"
                  inputProps={{ maxLength: 100 }}
                  value={formik.values.homeAddress}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                      return;
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.homeAddress && formik.errors.homeAddress
                  }
                  InputProps={{
                    endAdornment: formik.values.homeAddress ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            formik.setFieldValue("homeAddress", "")
                          }
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Autocomplete>
            </div>
            <div className="control_group w_50">
              <label> Home City</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="homeCity"
                id="homeCity"
                inputProps={{ maxLength: 30 }}
                value={formik.values.homeCity}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.homeCity && formik.errors.homeCity}
              />
            </div>
            <div className="control_group w_50">
              <label>Home State</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="homeState"
                id="homeState"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.homeState}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.homeState && formik.errors.homeState}
              />
            </div>
            <div className="control_group w_50">
              <label>Home Country</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="homeCountry"
                id="homeCountry"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.homeCountry}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.homeCountry && formik.errors.homeCountry
                }
              />
            </div>
            <div className="control_group w_50">
              <label>Home Postal Code</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="homePincode"
                id="homePincode"
                className="text_field"
                inputProps={{ maxLength: 10 }}
                value={formik.values.homePincode}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.homePincode && formik.errors.homePincode
                }
              />
            </div>

            {/* Residential Address */}
            <div className="control_group w_50">
              <label>Residential Address</label>
              <Autocomplete
                onLoad={onLoadResidential}
                onPlaceChanged={onPlaceChangeResidential}
              >
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  className="text_field"
                  name="residentialAddress"
                  id="residentialAddress"
                  inputProps={{ maxLength: 100 }}
                  value={formik.values.residentialAddress}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                      return;
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.residentialAddress &&
                    formik.errors.residentialAddress
                  }
                  InputProps={{
                    endAdornment: formik.values.residentialAddress ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            formik.setFieldValue("residentialAddress", "")
                          }
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Autocomplete>
            </div>
            <div className="control_group w_50">
              <label> Residential City</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="residentialCity"
                id="residentialCity"
                inputProps={{ maxLength: 30 }}
                value={formik.values.residentialCity}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.residentialCity &&
                  formik.errors.residentialCity
                }
              />
            </div>
            <div className="control_group w_50">
              <label>Residential State</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="residentialState"
                id="residentialState"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.residentialState}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.residentialState &&
                  formik.errors.residentialState
                }
              />
            </div>
            <div className="control_group w_50">
              <label>Residential Country</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="residentialCountry"
                id="residentialCountry"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.residentialCountry}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.residentialCountry &&
                  formik.errors.residentialCountry
                }
              />
            </div>
            <div className="control_group w_50">
              <label>Residential Postal Code</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="residentialPincode"
                id="residentialPincode"
                className="text_field"
                inputProps={{ maxLength: 10 }}
                value={formik.values.residentialPincode}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.residentialPincode &&
                  formik.errors.residentialPincode
                }
              />
            </div>

            {/* Place of Birth */}
            <div className="control_group w_50">
              <label>Place of Birth</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="placeOfBirth"
                id="placeOfBirth"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.placeOfBirth}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.placeOfBirth && formik.errors.placeOfBirth
                }
              />
            </div>
            {/* Residence Phone Number */}
            <div className="control_group w_50">
              <label>Residence Mobile Number</label>
              <PhoneInput
                enableSearch
                value={
                  formik.values.residenceDialCode + formik.values.residencePhone
                }
                country={"us"}
                inputClass="phoneInput"
                inputStyle={{ width: "100%" }}
                buttonClass="phoneBtn"
                placeholder="Residence Mobile Number"
                onChange={(phone, country) =>
                  handleChangeResidencePhone(phone, country)
                }
              />
              {error && !formik.values.residencePhone.length ? (
                <h6 className="err_msg">This field required</h6>
              ) : error && formik.values.residencePhone.length <= 5 ? (
                <h6 className="err_msg">
                  Phone number must contain atleast 6 digits
                </h6>
              ) : null}
            </div>
            {/* Residence Id */}
            <div className="control_group w_50">
              <label>Residence Id</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="residenceId"
                id="residenceId"
                className="text_field"
                inputProps={{ maxLength: 15 }}
                value={formik.values.residenceId}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.residenceId && formik.errors.residenceId
                }
              />
            </div>
            {/* Visa Expiry */}
            <div className="control_group w_50">
              <label> Visa Expiry</label>
              <TextField
                type="date"
                variant="outlined"
                fullWidth
                hiddenLabel
                name="visaExpiryDate"
                value={formik.values.visaExpiryDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputProps={{
                  inputProps: {
                    min: moment().format("YYYY-MM-DD"),
                    max: moment().add(10, "years").format("YYYY-MM-DD"),
                  },
                }}
              />
              {error && !formik.values.visaExpiryDate?.length ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>

            {/* Current Job Profession */}
            <div className="control_group w_50">
              <label>Current Job Profession</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="currentJobProfession"
                id="currentJobProfession"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.currentJobProfession}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.currentJobProfession &&
                  formik.errors.currentJobProfession
                }
              />
            </div>

            {/* Work Place Address */}
            <div className="control_group w_50">
              <label>Work Place Address</label>
              <Autocomplete
                onLoad={onLoadWork}
                onPlaceChanged={onPlaceChangeWork}
              >
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  className="text_field"
                  name="workAddress"
                  id="workAddress"
                  inputProps={{ maxLength: 100 }}
                  value={formik.values.workAddress}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                      return;
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.workAddress && formik.errors.workAddress
                  }
                  InputProps={{
                    endAdornment: formik.values.workAddress ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            formik.setFieldValue("workAddress", "")
                          }
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Autocomplete>
            </div>
            <div className="control_group w_50">
              <label>Work City</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="workCity"
                id="workCity"
                inputProps={{ maxLength: 30 }}
                value={formik.values.workCity}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.workCity && formik.errors.workCity}
              />
            </div>
            <div className="control_group w_50">
              <label>Work State</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="workState"
                id="workState"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.workState}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.workState && formik.errors.workState}
              />
            </div>
            {/* <div className="control_group w_50">
              <label>Work Country</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="workCountry"
                id="workCountry"
                className="text_field"
                inputProps={{ maxLength: 30 }}
                value={formik.values.workCountry}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.workCountry && formik.errors.workCountry
                }
              />
            </div> */}
            <div className="control_group w_50">
              <label>Work Postal Code</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="workPincode"
                id="workPincode"
                className="text_field"
                inputProps={{ maxLength: 10 }}
                value={formik.values.workPincode}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.workPincode && formik.errors.workPincode
                }
              />
            </div>
            {/* Company Name */}
            <div className="control_group w_50">
              <label>Company Name</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="companyName"
                id="companyName"
                className="text_field"
                inputProps={{ maxLength: 100 }}
                value={formik.values.companyName}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.companyName && formik.errors.companyName
                }
              />
            </div>
            {/* Employer Email */}
            <div className="control_group w_50">
              <label>Employer Email</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="employerEmail"
                id="employerEmail"
                className="text_field"
                inputProps={{ maxLength: 50 }}
                value={formik.values.employerEmail}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.employerEmail && formik.errors.employerEmail
                }
              />
            </div>
            {/* Emplopyer Phone Number */}
            <div className="control_group w_50">
              <label>Employer Phone Number</label>
              <PhoneInput
                enableSearch
                value={
                  formik.values.employerDialCode + formik.values.employerPhone
                }
                country={"us"}
                inputClass="phoneInput"
                inputStyle={{ width: "100%" }}
                buttonClass="phoneBtn"
                placeholder="Contact Number"
                onChange={(phone, country) =>
                  handleChangeEmployerPhone(phone, country)
                }
              />
              {error && !formik.values.employerPhone.length ? (
                <h6 className="err_msg">This field required</h6>
              ) : error && formik.values.employerPhone.length <= 5 ? (
                <h6 className="err_msg">
                  Phone number must contain atleast 6 digits
                </h6>
              ) : null}
            </div>
            {/* Applied Position */}
            <div className="control_group w_50">
              <label>Applied Position</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                name="appliedPosition"
                id="appliedPosition"
                className="text_field"
                inputProps={{ maxLength: 50 }}
                value={formik.values.appliedPosition}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.appliedPosition &&
                  formik.errors.appliedPosition
                }
              />
            </div>
            {/* Country of Birth */}
            <div className="control_group w_50">
              <label>Select Country of Birth</label>
              <Select
                fullWidth
                labelId="countryOfBirth"
                id="countryOfBirth"
                value={countryOfBirth}
                onChange={handleCountryfBirth}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                {countriesData?.length
                  ? countriesData?.map((item) => {
                      return (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.country_name || "-"}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
              {error && countryOfBirth === "default" ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            {/* Sex */}
            <div className="control_group w_50">
              <label>Select Sex</label>
              <Select
                fullWidth
                labelId="gender"
                id="gender"
                value={gender}
                onChange={handleGender}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                <MenuItem value={GENDER_STATUS.MALE}>
                  {GENDER_TYPES[1]}
                </MenuItem>
                <MenuItem value={GENDER_STATUS.FEMALE}>
                  {GENDER_TYPES[2]}
                </MenuItem>
              </Select>
              {error && gender === "default" ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>

            {/* Religion */}
            <div className="control_group w_50">
              <label>Select Religion</label>
              <Select
                fullWidth
                labelId="religion"
                id="religion"
                value={religion}
                onChange={handleReligion}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                {religionData?.length
                  ? religionData?.map((item) => {
                      return (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.religion || "-"}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
              {error && religion === "default" ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            {/* Citizenship */}
            <div className="control_group w_50">
              <label>Select Citizenship</label>
              <Select
                fullWidth
                labelId="citizenship"
                id="citizenship"
                value={citizenship}
                onChange={handleCitizenship}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                {citizenshipData?.length
                  ? citizenshipData?.map((item) => {
                      return (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.citizenship || "-"}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
              {error && citizenship === "default" ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            {/* Country of Residence */}
            <div className="control_group w_50">
              <label>Select Country of Residence</label>
              <Select
                fullWidth
                labelId="countryOfResidence"
                id="countryOfResidence"
                value={countryOfResidence}
                onChange={handleCountryOfResidence}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>

                {countriesData?.length
                  ? countriesData?.map((item) => {
                      return (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.country_name || "-"}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
              {error && countryOfResidence === "default" ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>

            {finalType === VISA_TYPES_SLUGS.STUDY_VISA ? (
              <>
                {/* Course Name */}
                <div className="control_group w_50">
                  <label>Course Name</label>
                  <TextField
                    variant="outlined"
                    placeholder="Enter here"
                    fullWidth
                    hiddenLabel
                    name="course_name"
                    id="course_name"
                    className="text_field"
                    inputProps={{ maxLength: 50 }}
                    value={formik.values.course_name}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                        return;
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.course_name && formik.errors.course_name
                    }
                  />
                </div>

                {/* School Name */}
                <div className="control_group w_50">
                  <label>School Name</label>
                  <TextField
                    variant="outlined"
                    placeholder="Enter here"
                    fullWidth
                    hiddenLabel
                    name="school_name"
                    id="school_name"
                    className="text_field"
                    inputProps={{ maxLength: 50 }}
                    value={formik.values.school_name}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                        return;
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.school_name && formik.errors.school_name
                    }
                  />
                </div>

                {/* School Address */}
                <div className="control_group w_50">
                  <label>School Address</label>
                  <Autocomplete
                    onLoad={onLoadSchool}
                    onPlaceChanged={onPlaceChangeSchool}
                  >
                    <TextField
                      variant="outlined"
                      placeholder="Enter here"
                      fullWidth
                      hiddenLabel
                      className="text_field"
                      name="school_address"
                      id="school_address"
                      inputProps={{ maxLength: 100 }}
                      value={formik.values.school_address}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                          return;
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.school_address &&
                        formik.errors.school_address
                      }
                      InputProps={{
                        endAdornment: formik.values.school_address ? (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                formik.setFieldValue("school_address", "")
                              }
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Autocomplete>
                </div>
                {/* School Leaving Certificate Name */}
                <div className="control_group w_50">
                  <label>School Leaving Certificate Name</label>
                  <TextField
                    variant="outlined"
                    placeholder="Enter here"
                    fullWidth
                    hiddenLabel
                    name="school_leaving_certificate"
                    id="school_leaving_certificate"
                    className="text_field"
                    inputProps={{ maxLength: 30 }}
                    value={formik.values.school_leaving_certificate}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                        return;
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.school_leaving_certificate &&
                      formik.errors.school_leaving_certificate
                    }
                  />
                </div>

                {/* School Leaving Certificate Country */}
                <div className="control_group w_50">
                  <label>
                    Select Country of Issuing School Leaving Certificate
                  </label>
                  <Select
                    fullWidth
                    labelId="countryOfSchoolLeavingCertificate"
                    id="countryOfSchoolLeavingCertificate"
                    value={countryOfSchoolLeavingCertificate}
                    onChange={handleCountryOfIssuingSchoolLeavingCertificate}
                  >
                    <MenuItem disabled value="default">
                      Select
                    </MenuItem>

                    {countriesData?.length
                      ? countriesData?.map((item) => {
                          return (
                            <MenuItem value={item?.id} key={item?.id}>
                              {item?.country_name || "-"}
                            </MenuItem>
                          );
                        })
                      : null}
                  </Select>
                  {error && countryOfSchoolLeavingCertificate === "default" ? (
                    <h6 className="err_msg">This field is required</h6>
                  ) : null}
                </div>
                {/* University Name */}
                <div className="control_group w_50">
                  <label>University Name</label>
                  <TextField
                    variant="outlined"
                    placeholder="Enter here"
                    fullWidth
                    hiddenLabel
                    name="university_name"
                    id="university_name"
                    className="text_field"
                    inputProps={{ maxLength: 50 }}
                    value={formik.values.university_name}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                        return;
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.university_name &&
                      formik.errors.university_name
                    }
                  />
                </div>
                {/* University Address */}
                <div className="control_group w_50">
                  <label>University Address</label>
                  <Autocomplete
                    onLoad={onLoadUniversity}
                    onPlaceChanged={onPlaceChangeUniversity}
                  >
                    <TextField
                      variant="outlined"
                      placeholder="Enter here"
                      fullWidth
                      hiddenLabel
                      className="text_field"
                      name="university_address"
                      id="university_address"
                      inputProps={{ maxLength: 100 }}
                      value={formik.values.university_address}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                          return;
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.university_address &&
                        formik.errors.university_address
                      }
                      InputProps={{
                        endAdornment: formik.values.university_address ? (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                formik.setFieldValue("university_address", "")
                              }
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Autocomplete>
                </div>
                {/* Language Proficiency*/}
                {/* <div className="control_group w_50">
                  <label>Language Proficiency</label>
                  <TextField
                    variant="outlined"
                    placeholder="Enter here"
                    fullWidth
                    hiddenLabel
                    name="language"
                    id="language"
                    className="text_field"
                    inputProps={{ maxLength: 80 }}
                    value={formik.values.language}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                        return;
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.language && formik.errors.language
                    }
                  />
                </div> */}
                <div className="control_group w_50">
                  <label>Language Proficiency</label>
                  <TextField
                    variant="outlined"
                    placeholder="Type and separate by comma"
                    fullWidth
                    hiddenLabel
                    name="language"
                    id="language"
                    className="text_field"
                    value={languageInput}
                    onChange={handleLanguageChange}
                    onBlur={formik.handleBlur}
                    inputProps={{ maxLength: 80 }}
                    helperText={
                      formik.touched.language && formik.errors.language
                    }
                  />
                  {/* Display Added Languages */}
                  {formik.values.language.length > 0 && (
                    <div className="language-tags">
                      {formik.values.language.map((lang, index) => (
                        <span key={index} className="tag">
                          {lang}
                          <button
                            type="button"
                            onClick={() => {
                              const updated = [...formik.values.language];
                              updated.splice(index, 1);
                              formik.setFieldValue("language", updated);
                            }}
                          >
                            &times;
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                {/*State Examination Participation */}
                <div className="control_group w_50">
                  <label>Participation in any state examination?</label>
                  <div
                    className="radio_group"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 30,
                      marginTop: 10,
                    }}
                  >
                    <label>
                      <input
                        style={{ marginRight: 10 }}
                        type="radio"
                        name="hasParticipatedStateExam"
                        value="true"
                        checked={hasParticipatedStateExam === true}
                        onChange={() => setHasParticipatedStateExam(true)}
                      />
                      Yes
                    </label>
                    <label>
                      <input
                        style={{ marginRight: 10 }}
                        type="radio"
                        name="hasParticipatedStateExam"
                        value="false"
                        checked={hasParticipatedStateExam === false}
                        onChange={() => {
                          setHasParticipatedStateExam(false);
                        }}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="control_group w_50" />
                {hasParticipatedStateExam ? (
                  <>
                    {/* {Marks Obtained} */}
                    <div className="control_group w_50">
                      <label>Marks Obtained</label>
                      <TextField
                        variant="outlined"
                        placeholder="Enter here"
                        fullWidth
                        hiddenLabel
                        name="marks_obtained"
                        id="marks_obtained"
                        className="text_field"
                        inputProps={{ maxLength: 3 }}
                        value={formik.values.marks_obtained}
                        onChange={(val) => {
                          if (
                            val.target.value === " " ||
                            val.target.value === "."
                          ) {
                            return;
                          } else if (isNumber(val.target.value)) {
                            formik.handleChange(val);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        helperText={
                          formik.touched.marks_obtained &&
                          formik.errors.marks_obtained
                        }
                      />
                    </div>
                    {/* Exam Date */}
                    <div className="control_group w_50">
                      <label> Exam Date</label>
                      <TextField
                        type="date"
                        variant="outlined"
                        fullWidth
                        hiddenLabel
                        name="exam_date"
                        value={formik.values.exam_date}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        InputProps={{
                          inputProps: {
                            max: moment().format("YYYY-MM-DD"),
                          },
                        }}
                      />
                      {error && !formik.values.exam_date?.length ? (
                        <h6 className="err_msg">This field is required</h6>
                      ) : null}
                    </div>
                  </>
                ) : null}
              </>
            ) : null}

            {/* Passport Details ------*/}

            <h5 className="sub_hdng">Passport Details</h5>

            <div className="control_group w_50">
              <label>Upload Passport</label>
              <div className="upload_box_doc">
                <label>
                  {profileImage ? (
                    <>
                      <IconButton
                        className="crossIcon"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setProfileImage("");
                          setProfile_picture_id(null);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>

                      {profileImage.endsWith(".pdf") ? (
                        <div
                          className="pdf-preview"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "10px",
                            height: "100%",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open(profileImage, "_blank");
                          }}
                        >
                          <img
                            src="/static/images/pdf.png"
                            alt="PDF"
                            style={{
                              width: "60px",
                              height: "60px",
                              cursor: "pointer",
                            }}
                          />
                          <p style={{ fontSize: "12px", marginTop: "5px" }}>
                            View PDF
                          </p>
                        </div>
                      ) : (
                        <figure
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(profileImage, "_blank");
                          }}
                        >
                          <img
                            src={profileImage}
                            alt="Upload"
                            style={{ width: "100%", height: "100%" }}
                          />
                        </figure>
                      )}
                    </>
                  ) : null}
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg,image/jpg,application/pdf",
                    }}
                    style={{ cursor: "pointer" }}
                    onChange={(e: any) => {
                      handleProfileUpload(e);
                      e.target.value = null;
                    }}
                  />

                  {profileImage ? null : (
                    <IconButton className="uploadIcon">
                      <label htmlFor="icon-button-file">
                        <Button component="span" className="upload_image_btn">
                          <img src="/static/images/upload.png" alt="Upload" />
                        </Button>
                      </label>
                    </IconButton>
                  )}
                </label>
              </div>
            </div>
            <div className="control_group w_50" />
            <div className="control_group w_50">
              <label>First Name</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="firstName"
                id="firstName"
                inputProps={{ maxLength: 30 }}
                value={formik.values.firstName}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.firstName && formik.errors.firstName}
              />
            </div>
            <div className="control_group w_50">
              <label>Middle Name</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="middleName"
                id="middleName"
                inputProps={{ maxLength: 30 }}
                value={formik.values.middleName}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.middleName && formik.errors.middleName
                }
              />
            </div>
            <div className="control_group w_50">
              <label>Last Name</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="lastName"
                id="lastName"
                inputProps={{ maxLength: 30 }}
                value={formik.values.lastName}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={formik.touched.lastName && formik.errors.lastName}
              />
            </div>
            <div className="control_group w_50">
              <label>Date of Birth</label>
              <TextField
                type="date"
                variant="outlined"
                fullWidth
                hiddenLabel
                name="dob"
                value={formik.values.dob}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputProps={{
                  inputProps: {
                    max: moment().subtract(18, "years").format("YYYY-MM-DD"),
                  },
                }}
              />
              {error && !formik.values.dob?.length ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            <div className="control_group w_50">
              <label>Passport Number</label>
              <TextField
                variant="outlined"
                placeholder="Enter here"
                fullWidth
                hiddenLabel
                className="text_field"
                name="passportNo"
                id="passportNo"
                inputProps={{ maxLength: 9 }}
                value={formik.values.passportNo}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                    return;
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.passportNo && formik.errors.passportNo
                }
              />
            </div>
            <div className="control_group w_50">
              <label>Issue Date</label>
              <TextField
                type="date"
                variant="outlined"
                fullWidth
                hiddenLabel
                name="issueDate"
                value={formik.values.issueDate}
                onChange={(e) => {
                  const issueDate = e.target.value;
                  formik.setFieldValue("issueDate", issueDate);

                  // Set expiry date = issue date + 10 years - 1 day
                  if (issueDate) {
                    const expiryDate = moment(issueDate)
                      .add(10, "years")
                      .subtract(1, "day")
                      .format("YYYY-MM-DD");
                    formik.setFieldValue("expiryDate", expiryDate);
                  }
                }}
                onBlur={formik.handleBlur}
                InputProps={{
                  inputProps: {
                    max: moment().format("YYYY-MM-DD"), // Future dates not allowed
                  },
                }}
              />
              {error && !formik.values.issueDate?.length ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            <div className="control_group w_50">
              <label>Expiry Date</label>
              <TextField
                type="date"
                variant="outlined"
                fullWidth
                hiddenLabel
                name="expiryDate"
                value={formik.values.expiryDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputProps={{
                  inputProps: {
                    min: moment().format("YYYY-MM-DD"), // Past dates not allowed
                    max: formik.values.issueDate
                      ? moment(formik.values.issueDate)
                          .add(10, "years")
                          .format("YYYY-MM-DD")
                      : moment().add(10, "years").format("YYYY-MM-DD"), // Max 10 years from issue date
                  },
                }}
              />
              {error && !formik.values.expiryDate?.length ? (
                <h6 className="err_msg">This field is required</h6>
              ) : null}
            </div>
            {finalType === VISA_TYPES_SLUGS.STUDY_VISA ? (
              <>
                {/* School Leaving Certificate */}
                <h5 className="sub_hdng">School Leaving Certificate</h5>
                <div className="control_group w_50">
                  <label>School Leaving Certificate</label>
                  <div className="upload_box_doc">
                    <label>
                      {schoolLeavingCertificate ? (
                        <>
                          <IconButton
                            className="crossIcon"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setSchoolLeavingCertificate("");
                              setSchoolLeavingCertificateId(null);
                            }}
                          >
                            <CloseIcon />
                          </IconButton>

                          {schoolLeavingCertificate?.endsWith(".pdf") ? (
                            <div
                              className="pdf-preview"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "10px",
                                height: "100%",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                window.open(schoolLeavingCertificate, "_blank");
                              }}
                            >
                              <img
                                src="/static/images/pdf.png"
                                alt="PDF"
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  cursor: "pointer",
                                }}
                              />
                              <p style={{ fontSize: "12px", marginTop: "5px" }}>
                                View PDF
                              </p>
                            </div>
                          ) : (
                            <figure
                              onClick={(e) => {
                                e.preventDefault();
                                window.open(schoolLeavingCertificate, "_blank");
                              }}
                            >
                              <img
                                src={schoolLeavingCertificate}
                                alt="Upload"
                                style={{ width: "100%", height: "100%" }}
                              />
                            </figure>
                          )}
                        </>
                      ) : null}
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file-school"
                        type="file"
                        inputProps={{
                          accept:
                            "image/png,image/jpeg,image/jpg,application/pdf",
                        }}
                        style={{ cursor: "pointer" }}
                        onChange={(e: any) => {
                          handleSchoolLeavingCertificateUpload(e);
                          e.target.value = null;
                        }}
                      />

                      {schoolLeavingCertificate ? null : (
                        <IconButton className="uploadIcon">
                          <label htmlFor="icon-button-file-school">
                            <Button
                              component="span"
                              className="upload_image_btn"
                            >
                              <img
                                src="/static/images/upload.png"
                                alt="Upload"
                              />
                            </Button>
                          </label>
                        </IconButton>
                      )}
                    </label>
                  </div>
                </div>
                {/* University Certificate */}
                <h5 className="sub_hdng">University Certificate</h5>
                <div className="control_group w_50">
                  <label>University Certificate</label>
                  <div className="upload_box_doc">
                    <label>
                      {universityCertificate ? (
                        <>
                          <IconButton
                            className="crossIcon"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setUniversityCertificate("");
                              setUniversityCertificateId(null);
                            }}
                          >
                            <CloseIcon />
                          </IconButton>

                          {universityCertificate?.endsWith(".pdf") ? (
                            <div
                              className="pdf-preview"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "10px",
                                height: "100%",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                window.open(universityCertificate, "_blank");
                              }}
                            >
                              <img
                                src="/static/images/pdf.png"
                                alt="PDF"
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  cursor: "pointer",
                                }}
                              />
                              <p style={{ fontSize: "12px", marginTop: "5px" }}>
                                View PDF
                              </p>
                            </div>
                          ) : (
                            <figure
                              onClick={(e) => {
                                e.preventDefault();
                                window.open(universityCertificate, "_blank");
                              }}
                            >
                              <img
                                src={universityCertificate}
                                alt="Upload"
                                style={{ width: "100%", height: "100%" }}
                              />
                            </figure>
                          )}
                        </>
                      ) : null}
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file-university"
                        type="file"
                        inputProps={{
                          accept:
                            "image/png,image/jpeg,image/jpg,application/pdf",
                        }}
                        style={{ cursor: "pointer" }}
                        onChange={(e: any) => {
                          handleUniversityCertificateUpload(e);
                          e.target.value = null;
                        }}
                      />

                      {universityCertificate ? null : (
                        <IconButton className="uploadIcon">
                          <label htmlFor="icon-button-file-university">
                            <Button
                              component="span"
                              className="upload_image_btn"
                            >
                              <img
                                src="/static/images/upload.png"
                                alt="Upload"
                              />
                            </Button>
                          </label>
                        </IconButton>
                      )}
                    </label>
                  </div>
                </div>
              </>
            ) : null}

            {/* Contract Scanned Document */}
            <h5 className="sub_hdng">Contract Scanned Document</h5>
            <div className="control_group w_50">
              <label>Contract Scanned Document</label>
              <div className="upload_box_doc">
                <label>
                  {contractScannedDocument ? (
                    <>
                      <IconButton
                        className="crossIcon"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setContractScannedDocument("");
                          setContractScannedDocumentId(null);
                        }}
                      >
                        <CloseIcon />
                      </IconButton>

                      {contractScannedDocument?.endsWith(".pdf") ? (
                        <div
                          className="pdf-preview"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "10px",
                            height: "100%",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open(contractScannedDocument, "_blank");
                          }}
                        >
                          <img
                            src="/static/images/pdf.png"
                            alt="PDF"
                            style={{
                              width: "60px",
                              height: "60px",
                              cursor: "pointer",
                            }}
                          />
                          <p style={{ fontSize: "12px", marginTop: "5px" }}>
                            View PDF
                          </p>
                        </div>
                      ) : (
                        <figure
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(contractScannedDocument, "_blank");
                          }}
                        >
                          <img
                            src={contractScannedDocument}
                            alt="Upload"
                            style={{ width: "100%", height: "100%" }}
                          />
                        </figure>
                      )}
                    </>
                  ) : null}
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file-contract"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg,image/jpg,application/pdf",
                    }}
                    style={{ cursor: "pointer" }}
                    onChange={(e: any) => {
                      handleContractUpload(e);
                      e.target.value = null;
                    }}
                  />

                  {contractScannedDocument ? null : (
                    <IconButton className="uploadIcon">
                      <label htmlFor="icon-button-file-contract">
                        <Button component="span" className="upload_image_btn">
                          <img src="/static/images/upload.png" alt="Upload" />
                        </Button>
                      </label>
                    </IconButton>
                  )}
                </label>
              </div>
            </div>

            {/* Identity Proof Document */}
            <h5 className="sub_hdng">Identity Proof</h5>
            <div className="control_group w_50">
              <label>Identity Proof</label>

              {identityProofDocuments?.length > 0 && (
                <div style={{ display: "flex", gap: "10px" }}>
                  {identityProofDocuments?.map((doc, index) => (
                    <div
                      key={index}
                      className="doc-item"
                      style={{
                        position: "relative",
                        width: "300px",
                        height: "150px",
                        margin: 0,
                      }}
                    >
                      <IconButton
                        className="crossIcon"
                        size="small"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const updatedDocs = [...identityProofDocuments];
                          const updatedIds = [...identityProofDocumentsId];
                          updatedDocs.splice(index, 1);
                          updatedIds.splice(index, 1);
                          setIdentityProofDocuments(updatedDocs);
                          setIdentityProofDocumentsId(updatedIds);
                        }}
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          background: "white",
                          zIndex: 1,
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>

                      {doc?.endsWith(".pdf") ? (
                        <div
                          className="pdf-preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(doc, "_blank");
                          }}
                        >
                          <img
                            src="/static/images/pdf.png"
                            alt="PDF"
                            style={{ width: "40px", height: "40px" }}
                          />
                          <p style={{ fontSize: "10px", marginTop: "5px" }}>
                            View PDF
                          </p>
                        </div>
                      ) : (
                        <figure
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(doc, "_blank");
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                            overflow: "hidden",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={doc}
                            alt="Uploaded"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </figure>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* Uploader Box */}
              {identityProofDocuments.length === 0 ||
              (identityProofDocuments.length < 2 &&
                !identityProofDocuments.some((doc: string) =>
                  doc.toLowerCase().endsWith(".pdf")
                )) ? (
                <div className="upload_box_doc">
                  <label htmlFor="icon-button-file-identity">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file-identity"
                      type="file"
                      inputProps={{
                        accept:
                          "image/png,image/jpeg,image/jpg,application/pdf",
                        multiple: true,
                      }}
                      onChange={(e: any) => {
                        handleIdentityUpload(e);
                        e.target.value = null;
                      }}
                    />
                    <IconButton className="uploadIcon">
                      <label htmlFor="icon-button-file-identity">
                        <Button component="span" className="upload_image_btn">
                          <img src="/static/images/upload.png" alt="Upload" />
                        </Button>
                      </label>
                    </IconButton>
                  </label>
                </div>
              ) : null}
            </div>

            {/* Other Documents */}
            {documentsListData?.length ? (
              <div>
                <h5 className="sub_hdng">Additional Documents</h5>
                {documentsListData?.map((doc) => (
                  <div key={doc.id} className="control_group w_50">
                    <label>{doc.document_name}</label>
                    <div className="upload_box_doc">
                      <label>
                        {otherDocuments[doc.id]?.url ? (
                          <>
                            <IconButton
                              className="crossIcon"
                              onClick={(e) => {
                                e.preventDefault();
                                setOtherDocuments((prev) => {
                                  const updated = { ...prev };
                                  delete updated[doc.id];
                                  return updated;
                                });
                              }}
                            >
                              <CloseIcon />
                            </IconButton>

                            {otherDocuments[doc.id].url.endsWith(".pdf") ? (
                              <div
                                className="pdf-preview"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "10px",
                                  height: "100%",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  window.open(
                                    otherDocuments[doc.id].url,
                                    "_blank"
                                  );
                                }}
                              >
                                <img
                                  src="/static/images/pdf.png"
                                  alt="PDF"
                                  style={{ width: "60px", height: "60px" }}
                                />
                                <p
                                  style={{ fontSize: "12px", marginTop: "5px" }}
                                >
                                  View PDF
                                </p>
                              </div>
                            ) : (
                              <figure
                                onClick={() =>
                                  window.open(
                                    otherDocuments[doc.id].url,
                                    "_blank"
                                  )
                                }
                              >
                                <img
                                  src={otherDocuments[doc.id].url}
                                  alt="Upload"
                                  style={{ width: "100%", height: "100%" }}
                                />
                              </figure>
                            )}
                          </>
                        ) : null}

                        <Input
                          sx={{ display: "none" }}
                          type="file"
                          inputProps={{
                            accept:
                              "image/png,image/jpeg,image/jpg,application/pdf",
                          }}
                          onChange={(e) =>
                            handleOtherDocumentsUpload(e, {
                              docid: doc.id,
                              name: doc.document_name,
                            })
                          }
                        />

                        {!otherDocuments[doc.id]?.url && (
                          <IconButton className="uploadIcon">
                            <label htmlFor={`icon-button-file-${doc.id}`}>
                              <Button
                                component="span"
                                className="upload_image_btn"
                              >
                                <img
                                  src="/static/images/upload.png"
                                  alt="Upload"
                                />
                              </Button>
                            </label>
                          </IconButton>
                        )}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
          <div className="form_btn end">
            <Button
              className="btn btn_secondary"
              type="submit"
              onClick={() => setError(true)}
            >
              Save Changes
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default EditApplication;
